module.exports = __webpack_public_path__ + "static/media/original.4797a80c.jpg";